export { default } from './UpdatePaymentMethodPanel';
